import React from "react";
import "./Destinations.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Heading from "../../../utls/Heading";
const Destinations = () => {
  return (
    <>
      <div className="Destination">
        <div className="container ServiceOffering">
          <div className="row">
            <div className="col-md-12 ">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <Heading className="customheadings text-center">
                  <span>Now Serving </span>30+ Destinations Worldwide!
                </Heading>
                <p className="heading-para grotesk-headings text-center">
                  Blueberry Travel has made its way towards more than 30
                  strategic locations globally, offering top-tier travel
                  services wherever your business journey takes you. From
                  crowded cities to growing business hubs, we guarantee a smooth
                  and flawless experience tailored to each unique market’s
                  needs. Join us as we redefine business travel around the
                  world!
                </p>
              </div>
            </div>
          </div>
          <div className="row px-lg-5 px-md-0 px-4 mlTab">
            <div className="col-lg-4 col-md-4 col-12  mt-3 d-flex justify-content-center">
              <div className="DT-box1 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/dest1.png"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-global">
                      LOCALISED EXPERTISE
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      We offer unique local insight, ensuring your trips are
                      guided by the knowledge of experts who genuinely
                      understand each destination’s unique needs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12  mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box2">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/dest2.png"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-global">
                      CONSISTENT STANDARDS
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      Wherever you go, our commitment to quality service stays
                      intent. We deliver exceptional experience across all
                      points of contact, ensuring a stress-free journey every
                      single time.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12  mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/dest3.png"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head-global">
                      END-TO-END SUPPORT
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      Our experts are available around the clock to handle any
                      travel challenges. From your corporate trip planning to
                      arrival and beyond, we provide complete support at every
                      stage of your journey.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Destinations;
